<ng-container *ngIf="href; else buttonComponent">
  <a
    [id]="id"
    [href]="href"
    class="ant-btn ant-btn-link"
    download
  >
    <ng-container *ngIf="iconType">
      <i nz-icon [nzType]="iconType"></i>
    </ng-container>

    <span>{{ title | crmTranslate }}</span>
  </a>
</ng-container>

<ng-template #buttonComponent>
  <button
    [id]="id"
    nz-button
    [type]="type"
    [nzType]="buttonType ?? 'default'"
    [nzLoading]="loading"
    [disabled]="disabled"
    [ngClass]="buttonClass"
    [ngStyle]="style"
  >
    <ng-container *ngIf="iconType">
      <i nz-icon [nzType]="iconType"></i>
    </ng-container>

    {{ title | crmTranslate }}
  </button>
</ng-template>

